import { render, staticRenderFns } from "./Dialog_ChooseFreeClassroom.vue?vue&type=template&id=553cb98a&scoped=true&"
import script from "./Dialog_ChooseFreeClassroom.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChooseFreeClassroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553cb98a",
  null
  
)

export default component.exports